<!--
 * @Description: 合作等级变更
 * @Author: wangwangwang
 * @Date: 2020-11-30 20:21:38
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-07 12:03:15
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type*1!==1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{billCode}}</span>
                <span class="text">制单日期：{{billDate}}</span>
              </div>
              <div class="right">
                <span>发起人：{{applyPerson}}</span>
                <span class="text">状态：{{taskTypeText[taskStatus*1]}}</span>
              </div>
            </div>
            <div style="margin-top:20px;">
              <el-form :inline="true" :model="formData" label-width="110px">
                <el-form-item>
                  <span slot="label">公司</span>
                  <el-input v-model="formData.company" disabled placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item >
                  <span slot="label">站点</span>
                  <el-input v-model="formData.station" disabled placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">供应商名称</span>
                  <el-input v-model="formData.name" disabled placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">供应商类别</span>
                  <el-input v-model="formData.typeName" disabled placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label" style="color: #ff0000">合作等级</span>
                  <el-select v-model="formData.gradeId" :disabled="readOnly" placeholder="请选择">
                    <el-option v-for="item in gradelist" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <div>
                  <el-form-item>
                    <span slot="label">协作单位</span>
                    <el-input v-model="coopUnit" style="width:800px;" disabled type="textarea" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible" @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish" @handleBusiness="handleBusiness"/>
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
import { getDicType } from "@/api/common.js";
import { queryListsByPid } from "@/api/GHnumber/supplier.js";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: '合作等级审核',
      billCode: '',
      billDate: '',
      applyPerson: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      taskStatus: 0,
      readOnly: false,
      showSendVisible: false,
      formData: {},
      gradelist: [],
      coopUnit: '',
    }
  },
  methods: {
    handleBusiness () {
      this.formData.gradeName = this.gradelist.find(item => item.id === this.formData.gradeId).itemName;
      const params = {
        process_success: {
          url: '/icps/system/sign/dataCollection/supplier/saveOrUpdate',
          data: {
            ...this.formData,
          },
          httpMethod: 'post',
        },
        process_failure: ''
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description: 
     * @Param: 1为保存，2为最后提交/3 中间提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish() {
    },
    /**
     * @Description: 流程头部操作
     * @Param: 
     * @Author: wangwangwang
     * @param {*} type
     */
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType*1 !== 2) { // 提交流程
        this.showSendVisible = true;
        return
      }
      if (!this.formData.gradeId) {
        this.$message.warning('请选择合作等级');
        return
      }
      const data = {
        dataSource: 'ChangeLevelCoop',
        dataContent: JSON.stringify({ ...this.formData }), // 业务数据
        process_success: {
          url: '/icps/system/sign/dataCollection/supplier/saveOrUpdate',
          data: {
            ...this.formData,
          },
          httpMethod: 'post',
        },
      }
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param: 
     * @Author: wangwangwang
     */
    initFlowsData(data) {
      if (data.stations) {
        data.station = JSON.parse(data.stations).map(item => item.name).join(',');
      }
      this.formData = data;
      queryListsByPid({ supplierId: data.id }).then((res) => {
        if (res.code === 1001) {
          this.coopUnit = res.data.map(item => item.name).join(',');
        }
      });
    },
    initFlowsData2() {
      const { query } = this.$route;
      this.formData = JSON.parse(query.dataContent);
      this.title = query.taskName;
      this.applyPerson = query.createUserName;
      this.taskStatus = query.taskStatus;
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
      queryListsByPid({ supplierId: this.formData.id }).then((res) => {
        if (res.code === 1001) {
          this.coopUnit = res.data.map(item => item.name).join(',');
        }
      });
    },
    sendCode(code) {
      this.billCode = code;
    },
  },
  mounted() {
    console.log('******************');
    getDicType({ code: "Levelofcooperation" }).then((res) => {
      this.gradelist = res.data.items;
    });
    const { query } = this.$route;
    if (query.type * 1 === 1) { // 发起流程
      this.initFlowsData(query);
      this.$refs.flowcontent.initBaseData('ChangeLevelCoop');
      this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
      this.applyPerson = getUserInfo().userRealName;
      return
    }
    this.initFlowsData2();
    if (query.isReadOnly*1===1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.nav_title {
  @include discen_al;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
</style>
